// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import ForgotPassword from './ForgotPassword';

ReactDOM.render(<ForgotPassword />, document.getElementById('root'));

